<template>
  <div class="publicItems">
    <div class="template_box">
      <span>当前规则id:{{ id }}</span>
      <div>
        <el-button type="success" @click="addAccountBind">新增</el-button>
      </div>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="account_id"
          label="广告账户id"
        />
        <el-table-column
          prop="status"
          label="状态"
        >
          <template scope="scope">
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.status"
                :width="60"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
                @change="statusChange(scope.row)"
              />
              <div
                v-if="scope.row.status === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >{{ scope.row.status_text }}</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >禁用</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="100"
        >
          <template scope="scope">
            <el-button type="danger" size="mini" @click="modify(scope.row)">解除绑定</el-button>
            <el-button type="success" size="mini" @click="openHistory(scope.row)">自动开启记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      title="账号绑定规则"
      :visible.sync="add_bind"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="80%"
      style="min-width:680px"
    >
      <tencent-account :role_id="id" @bind="addBind" @close="add_bind=false" />
    </el-dialog>
    <el-dialog
      title="自动开启记录"
      :visible.sync="open_history_visible"
      :append-to-body="true"
      width="80%"
      style="min-width:680px"
    >
      <open-history ref="history" />
    </el-dialog>

  </div>
</template>

<script>

import { addMaterial_bind_relations, editMaterial_bind_relations } from '@/api/enormousAmountMaterialReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  advertiserList,
  InterPutRuleBandAccountBind,
  InterPutRuleBandAccountList,
  InterPutRuleBandAccountUpdSts, InterPutRuleUnBand
} from '@/api/customer'
import TencentAccount from '@/views/tencentAD/IntPut/components/tencentAccount.vue'
import OpenHistory from '@/views/tencentAD/IntPut/components/openHistory.vue'
export default {
  components: {
    OpenHistory,
    TencentAccount,
    PaginationRight
  },
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        rule_id: this.id
      },
      group_name: null,
      dialogVisible: false,
      drawerItem: {},
      add_bind: false,
      account_data: null,
      open_history_visible: false
    }
  },
  watch: {
    id(newVal, oldVal) {
      this.parameter.rule_id = newVal
      this.getDataList()
    }
  },
  created() {
    if (this.id == null) {
      this.$message.error('当前页面id丢失,请重新进入页面')
    }
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await InterPutRuleBandAccountList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    // 解绑
    modify(row) {
      console.log(row)
      this.$confirm('确定要解绑当前规则吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        InterPutRuleUnBand({
          account_ids: [row.account_id]
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('解绑成功')
            this.getDataList()
          }
        })
      })
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList(true)
    },

    // 添加绑定
    async determine(obj, start_time) {
      const bool = !!this.drawerItem.id
      if (bool) {
        await editMaterial_bind_relations(this.drawerItem.id, obj)
      } else {
        await addMaterial_bind_relations({ ...obj, start_time })
      }

      this.$message({
        message: bool ? '修改关系成功' : '创建关系成功',
        type: 'success'
      })
      this.isL = true
      this.drawerItem = {}
      this.dialogVisible = false
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10
      }
      this.group_name = null
      this.getDataList()
    },

    // 创建按钮的点击事件的处理函数
    establish() {
      // console.log('有无数据回显===', this.isL, this.drawerItem)
      this.drawerItem = this.getBindingRelationship || {}
      this.dialogVisible = true
      this.isL = false
    },
    statusChange(row) {
      InterPutRuleBandAccountUpdSts({ account_ids: [row.account_id], status: row.status })
        .then(res => {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
        })
    },
    addAccountBind() {
      this.add_bind = true
    },
    accountList() {
      advertiserList(this.query).then(res => {
        this.account_data = res.data.list
      })
    },
    addBind(val) {
      console.log(this.id)
      console.log(val)
      InterPutRuleBandAccountBind({
        rule_id: this.id,
        account_ids: val
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('绑定成功')
          this.add_bind = false
          this.getDataList()
        }
      })
    },
    openHistory(val) {
      this.open_history_visible = true
      this.$nextTick(() => {
        if (this.$refs.history && typeof this.$refs.history.open === 'function') {
          this.$refs.history.open(val.account_id, this.id)
        } else {
          console.warn('history组件没有初始化.')
        }
      })
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      margin-right: 5px;
      display: inline-block;
      width: 55px;
    }
    .item_input{
      width:200px
    }
  }
}
.template_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
